module.exports = ".highlightedLi{\r\n    background-color: rgba(255,255,255,1) !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/sidebar.component.css
// module id = ./src/app/sidebar/sidebar.component.css
// module chunks = main